import { useAuth } from "@/contexts/AuthProvider"
import { HandCoins, Home, Trophy } from "lucide-react"
import { NavLink } from "react-router-dom"

export function NavBar() {
    const { isAuthorized } = useAuth();

    return (
        <div className="bg-primary h-12 w-screen fixed bottom-0 rounded-t-2xl md:hidden">
            <div className="flex h-full items-center gap-4 justify-around mx-4">
                <NavLink to="/" className={({ isActive }) => {
                    if (isActive) {
                        return "flex flex-col items-center gap-0.5 text-xs font-bold text-buttondefault-foreground"
                    }

                    return "flex flex-col items-center gap-0.5 text-xs text-buttondefault-foreground/90  hover:text-buttondefault-foreground"
                }}>
                    <Home size={18} />
                    Início
                </NavLink>
                <NavLink to="/compra/titulos" className={({ isActive }) => {
                    if (isActive) {
                        return "flex flex-col items-center gap-0.5 text-xs font-bold text-buttondefault-foreground"
                    }

                    return "flex flex-col items-center gap-0.5 text-xs text-buttondefault-foreground/90  hover:text-buttondefault-foreground"
                }}>
                    <HandCoins size={18} />
                    Comprar
                </NavLink>
                <NavLink to="/resultados" className={({ isActive }) => {
                    if (isActive) {
                        return "flex flex-col items-center gap-0.5 text-xs font-bold text-buttondefault-foreground"
                    }

                    return "flex flex-col items-center gap-0.5 text-xs text-buttondefault-foreground/90 hover:text-buttondefault-foreground"
                }}>
                    <Trophy size={18} />
                    Resultados
                </NavLink>
                {
                    isAuthorized && (
                        <NavLink to="/compra/creditos" className={({ isActive }) => {
                            if (isActive) {
                                return "flex flex-col items-center gap-0.5 text-xs font-bold text-buttondefault-foreground"
                            }

                            return "flex flex-col items-center gap-0.5 text-xs text-buttondefault-foreground/90 hover:text-buttondefault-foreground"
                        }}>
                            <Trophy size={18} />
                            Inserir Créditos
                        </NavLink>
                    )
                }
            </div>
        </div>
    )
}
